// Types
import { RootState } from 'types/RootState.types';

export const getAddressBookAddressIdToBeRemovedSelector = (state: RootState) => state.addressBook?.addressIdToBeRemoved;
export const getAddressBookEditableAddressSelector = (state: RootState) => state.addressBook?.editableAddress;
export const getAddressBookAPICallActiveSelector = (state: RootState) =>
  state.addressBook?.getAddressBookAPICallActive ?? false;
export const getAddressBookInvalidAddressSelector = (state: RootState) => state.addressBook?.invalidAddress ?? false;
export const getAddressBookLoadingSelector = (state: RootState) => state.addressBook?.loading ?? false;
export const getAddressBookRemoveAddressFailedSelector = (state: RootState) =>
  state.addressBook?.removeAddressFailed ?? false;
export const getAddressBookRemoveAddressOverlayVisibleSelector = (state: RootState) =>
  state.addressBook?.removeAddressOverlayVisible ?? false;
export const getAddressBookRemoveAddressSuccessSelector = (state: RootState) =>
  state.addressBook?.removeAddressSuccess ?? false;
export const getAddressBookUseAddressFailedSelector = (state: RootState) =>
  state.addressBook?.useAddressFailed ?? false;
